import milestoneService from 'resources/milestone/milestone.service';
import { extendMilestonesWithTasks } from 'resources/milestone/milestone.operations';


export const getAllKitsMilestonesWithTasks = async (companyId) => {
  if (!companyId) return [];

  const milestones = await milestoneService.getAllKitsMilestones(companyId);

  const milestonesWithTasks = await extendMilestonesWithTasks(milestones);
  return milestonesWithTasks;
};
